function Banner(props) {
    return ( 
        <div className='-mt-2.5 banner__text relative h-20 mx-auto bg-[var(--theme-primary)] rounded-lg py-2'>
        {props?.text}
        </div>
     );
}

export default Banner;